<template>
  <div :class="{'coupon-fields--standalone': standalone}">
    <div class="row">
      <div class="col-md-12 text-center " v-if="!standalone">
          <p-checkbox
                  @input="changeType()"
                  key="COUPON"
                  v-model="addcoupon"
                  class="text-purple"
                  :label="$t('marketingCampaigns.addCoupon')">
            <h4 ref="COUPON" class="coupon-selection" :class="activeButton == 'COUPON' ? 'purple' : 'gray'" name="coupon_option">{{$t('marketingCampaigns.addCoupon')}}</h4>
          </p-checkbox>
      </div>
      <div :disabled="model.type != 'COUPON'">
        <div class="col-md-12 pad-bt-15 text-center">
          <label class="pad-rg-5 valign-top">{{$t('marketingCampaigns.applyTo')}}:</label>
          <p-radio v-for="(type, key) in couponUsageTypes"
                :key="key"
                v-model="coupons.usage_type"
                v-validate="modelValidations.usage_type"
                :label="key"
                :inline="true"
                :disabled="model.type != 'COUPON'">{{$t('marketingCampaigns.'+type)}}</p-radio>
        </div>
        <div :class="coupons.usage_type == 'PRODUCTS' && !isSpinningWheelFreeProductCoupon ? '' : 'col-md-offset-3'" class="col-md-6 ">
          <div class="form-group">
            <p-radio v-for="(type, key) in couponType"
                v-model="coupons.type"
                v-validate="modelValidations.type"
                :key="key"
                :label="key"
                :disabled="model.type != 'COUPON'"
                :inline="true">{{$t('couponsTypes.' + key)}}</p-radio>

            <div v-if="isFreeProductCoupon"
                 class="box free-product-box"
                 style="border: 1px solid #5e35b1; padding: 15px; margin-top: 15px; margin-bottom: 15px; background: #faf8ff;">
              <label class="text-purple" style="font-weight: 600;">{{$t('marketingCampaigns.freeProduct')}}*</label>
              <p class="help-block" style="margin-top: 5px; margin-bottom: 10px;">{{ $t(isSpinningWheelFreeProductCoupon ? 'spinningWheel.freeProductCouponHelp' : 'marketingCampaigns.freeProductHelp') }}</p>
              <v-select v-model="selectedFreeProduct"
                        :options="freeProducts"
                        label="name"
                        :filterable="false"
                        :disabled="model.type != 'COUPON'"
                        :placeholder="$t('marketingCampaigns.freeProductPlaceholder')"
                        @search="searchFreeProducts"
                        @input="onFreeProductSelected">
              </v-select>
              <small class="text-muted" style="display: block; margin-top: 6px;">
                {{ $t('marketingCampaigns.freeProductSearchHint') }}
              </small>
              <small class="text-danger" v-if="errorFreeProduct">
                {{ errorFreeProduct }}
              </small>
              <div class="form-group" style="margin-top: 15px; margin-bottom: 0;">
                <label>{{$t('marketingCampaigns.minOrderValue')}}</label>
                <input type="number"
                       min="0"
                       step="0.01"
                       :placeholder="$t('marketingCampaigns.minOrderValuePlaceholder')"
                       v-model="coupons.min_order_value"
                       class="form-control"
                       :disabled="model.type != 'COUPON'">
                <small class="text-muted" style="display: block; margin-top: 6px;">
                  {{ $t('marketingCampaigns.minOrderValueHelp') }}
                </small>
              </div>
            </div>

            <template v-if="!isFreeProductCoupon">
            <br><label for="">{{$t('marketingCampaigns.addValue')}}</label><br>
            <div class="box" style="border: 1px solid #f2f2f2; padding: 10px;">
              <div  class="form-group firstValue" >
                <div class="row">
                  <div class="col-md-5">
                    <label>{{$t('marketingCampaigns.minValue')}}*</label>
                    <input type="number"
                           min="0"
                           :placeholder="$t('marketingCampaigns.value')"
                           v-validate="{ required:true, min_value:0 }"
                           v-model="coupons.from_value"
                           class="form-control"
                           :disabled="model.type != 'COUPON'">
                  </div>
                  <div class="col-md-5">
                    <label>{{$t('marketingCampaigns.value')}} ({{coupons.type != 'FIXED' ? '%' : currency}})*</label>
                    <input type="number"
                           min="0"
                           :placeholder="$t('marketingCampaigns.value')"
                           v-validate="{ customConditionCouponValue }"
                           v-model="coupons.discount"
                           class="form-control"
                           :disabled="model.type != 'COUPON'">
                    <small class="text-danger" v-if="errors.discount">
                      {{ getError('discount') }}
                    </small>
                  </div>
                  <div class="col-md-2">
                  </div>
                </div>
              </div>
            <!-- <template v-if="coupons.is_waterfall"> -->
              <div v-for="(waterfall, indexWaterfall) in coupons.waterfall_discounts" class="form-group">
                <div  class="form-group" >
                  <div class="row">
                    <div class="col-md-5">
                      <label>{{$t('marketingCampaigns.minValue')}}</label>
                      <input type="number"
                             min="0"
                             :placeholder="$t('marketingCampaigns.value')"
                             v-validate="modelValidations.from_value"
                             v-model="waterfall.from_value"
                             class="form-control"
                             :disabled="model.type != 'COUPON' && coupons.is_waterfall">
                    </div>
                    <div class="col-md-5">
                      <label>{{$t('marketingCampaigns.value')}} ({{coupons.type != 'FIXED' ? '%' : currency}})</label>
                      <input type="number"
                             min="0"
                             :placeholder="$t('marketingCampaigns.value')"
                             v-validate="{ required:true, customCondition }"
                             v-model="waterfall.discount_value"
                             class="form-control"
                             :disabled="model.type != 'COUPON' && coupons.is_waterfall">
                    </div>
                    <div class="col-md-2">
                      <div style="padding-top: 30px;">
                        <button class="btn btn-danger btn-icon" :disabled="model.type != 'COUPON'" @click.prevent="deleteCascade(indexWaterfall)"><i :title="$t('general.remove')" class="ti-close "></i></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button class="btn btn-icon btn-info" :disabled="model.type != 'COUPON'" @click.prevent="addNewCascade()"><i class="ti-plus"></i></button>
              <p-checkbox
                v-if="coupons.usage_type == 'PRODUCTS' && coupons.waterfall_discounts && coupons.waterfall_discounts.length >= 1"
                v-model="coupons.waterfall_restriction"
                class="text-purple"
                style="margin-bottom: -10px; margin-top: 20px;">
                <h6 class="coupon-selection pad-to-7">{{$t('marketingCampaigns.doesApplyOnPromotionalItems')}}</h6>
              </p-checkbox>
            <!-- </template> -->
            </div>
            </template>
          </div>

          <!-- Coupons tab only: "subscription coupon" / "used in automatic marketing" checkboxes (CouponForm) -->
          <slot name="before-auto-apply"></slot>

          <div class="form-group">
            <p-checkbox
              @input="handleAutoApply()"
              key="couponAutoApply"
              v-model="coupons.auto_apply"
              :disabled="model.type != 'COUPON' || isSubscriptionCoupon || isAutomationCoupon || coupons.second_use_auto_coupon == true || coupons.coupon_has_multiple_codes == true"
              class="text-purple"
              label="">
            <h6 ref="interval" class="coupon-selection pad-to-7"  name="coupon_interval">{{$t('marketingCampaigns.isAutoApplyCheck')}}</h6>
            </p-checkbox>
          </div>

          <div class="form-group">
            <p-checkbox
              @input=""
              key="cuponIsCumulative"
              v-model="coupons.is_cumulative"
              :disabled="model.type != 'COUPON' || isSubscriptionCoupon"
              class="text-purple"
              label="">
            <h6 ref="interval" class="coupon-selection pad-to-7"  name="coupon_interval">{{$t('marketingCampaigns.isCumulativeCheck')}}</h6>
            </p-checkbox>
          </div>

          <div class="form-group">
            <p-checkbox
              @input="handleAutoApply()"
              key="isSecondUseCheck"
              v-model="coupons.second_use_auto_coupon"
              :disabled="model.type != 'COUPON' || isSubscriptionCoupon || isAutomationCoupon || coupons.auto_apply == true || coupons.coupon_has_multiple_codes == true"
              class="text-purple"
              label="">
            <h6 ref="interval" class="coupon-selection pad-to-7"  name="coupon_interval">{{$t('marketingCampaigns.isSecondUseCheck')}}</h6>
            </p-checkbox>
          </div>


          <div class="form-group">
            <p-checkbox
              @input="handleAutoApply()"
              key="isSecondUseCheck"
              v-model="coupons.coupon_has_multiple_codes"
              :disabled="model.type != 'COUPON' || isSubscriptionCoupon || isAutomationCoupon || coupons.auto_apply == true || coupons.second_use_auto_coupon == true"
              class="text-purple"
              label="">
            <h6 ref="interval" class="coupon-selection pad-to-7"  name="coupon_interval">{{$t('marketingCampaigns.couponHasMultipleCodes')}}</h6>
            </p-checkbox>
          </div>

          <div class="form-group coupon-subscription-nocode" v-if="isSubscriptionCoupon">
            <i class="fa fa-info-circle"></i> {{ $t('marketingCoupons.subscriptionNoCode') }}
          </div>
          <!-- automatic marketing coupon: optional INFORMATIVE code (shown in the pushes, can't be typed in) -->
          <div class="form-group coupon-automation-nocode" v-if="isAutomationCoupon">
            <i class="fa fa-info-circle"></i> {{ $t('marketingCoupons.automationInfoCode', { cod: '{cod}' }) }}
          </div>
          <div class="form-group coupon-code-row" v-if="!coupons.coupon_has_multiple_codes && !isSubscriptionCoupon">
            <div class="coupon-code-row__main">
              <label>{{ isAutomationCoupon ? $t('marketingCoupons.automationCodeLabel') : $t('marketingCampaigns.code') + '*' }}</label>
              <input type="text"
                     :placeholder="isAutomationCoupon ? $t('marketingCoupons.automationCodePlaceholder') : $t('marketingCampaigns.code')"
                     v-validate="isAutomationCoupon ? automationCodeValidation : modelValidations.coupon_code"
                     v-model="coupons.coupon_code"
                     ref="couponCode"
                     :disabled="model.type != 'COUPON'"
                     class="form-control">
              <small class="text-danger" v-if="errors.coupon_code">
                {{ $t('validations.requiredField') }}
              </small>
              <small class="text-danger" v-if="couponError">
                {{ couponError }}
              </small>
              <br v-if="couponError" />
              <button :disabled="model.type != 'COUPON'" class="btn btn-purple mar-to-10 mar-bt-10 generate-code" @click.prevent="generateCode()">{{$t('marketingCampaigns.generateCode')}}</button>
            </div>
            <div class="coupon-qr" v-if="singleQrUrl && !isAutomationCoupon">
              <a :href="singleQrUrl" target="_blank" :title="$t('marketingCoupons.openQr')">
                <img :src="singleQrUrl" class="coupon-qr__img" alt="QR">
              </a>
              <button class="btn btn-purple btn-sm" :disabled="exporting" @click.prevent="exportCodes()">
                <i class="fa fa-download"></i> {{ $t('marketingCoupons.export') }}
              </button>
            </div>
          </div>




          <div class="box coupon-generator" v-if="coupons.coupon_has_multiple_codes">
            <label>{{ $t('marketingCoupons.generatorTitle') }}</label>
            <div class="row">
              <div class="col-md-4 form-group">
                <label>{{ $t('marketingCoupons.generatorCount') }}</label>
                <input type="number" min="1" max="1000" class="form-control" v-model.number="generator.count">
              </div>
              <div class="col-md-4 form-group">
                <label>{{ $t('marketingCoupons.generatorLength') }}</label>
                <input type="number" min="4" max="20" class="form-control" v-model.number="generator.length">
              </div>
              <div class="col-md-4 form-group">
                <label>{{ $t('marketingCoupons.generatorCharset') }}</label>
                <select class="form-control" v-model="generator.charset">
                  <option value="alnum">{{ $t('marketingCoupons.generatorCharsetAlnum') }}</option>
                  <option value="letters">{{ $t('marketingCoupons.generatorCharsetLetters') }}</option>
                  <option value="digits">{{ $t('marketingCoupons.generatorCharsetDigits') }}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 form-group">
                <label>{{ $t('marketingCoupons.generatorPrefix') }}</label>
                <input type="text" maxlength="20" class="form-control" v-model="generator.prefix" placeholder="VARA-">
              </div>
              <div class="col-md-4 form-group">
                <label>{{ $t('marketingCoupons.generatorSuffix') }}</label>
                <input type="text" maxlength="20" class="form-control" v-model="generator.suffix" placeholder="-26">
              </div>
              <div class="col-md-4 form-group">
                <label>{{ $t('marketingCoupons.generatorGroup') }}</label>
                <select class="form-control" v-model.number="generator.group">
                  <option :value="0">{{ $t('marketingCoupons.generatorGroupNone') }}</option>
                  <option :value="3">3 (ABC-DEF)</option>
                  <option :value="4">4 (ABCD-EFGH)</option>
                  <option :value="5">5 (ABCDE-FGHIJ)</option>
                </select>
              </div>
            </div>
            <p class="text-muted">{{ $t('marketingCoupons.generatorExample') }}: <b>{{ generatorExample }}</b></p>
            <small class="text-danger" v-if="generatorError">{{ generatorError }}<br></small>
            <button class="btn btn-purple" :disabled="generating" @click.prevent="generateCodes()">
              <i class="fa fa-magic"></i> {{ $t('marketingCoupons.generate') }}
            </button>
          </div>
          <div class="box" style="border: 1px solid #f2f2f2; padding: 10px;" v-if="coupons.coupon_has_multiple_codes">
            <label>Import Codes</label><br><br>
            <div  class="form-group">
              <div class="row">
                <div class="col-md-8">
                  <textarea style="width: 100%; resize: vertical;" v-model="importedCodes">
                  </textarea>
                </div>
                <div class="col-md-4">
                  <button class="btn btn-purple" @click="importCodes()">Import</button>
                </div>
              </div>
            </div>
          </div>
          <div class="box" style="border: 1px solid #f2f2f2; padding: 10px; display: flex; align-items: self-start; flex-direction: column;" v-if="coupons.coupon_has_multiple_codes">
            <div class="coupon-codes-header">
              <label>Coduri Cupon ({{ activeCodes.length }})</label>
              <div v-if="activeCodes.length">
                <button class="btn btn-danger btn-sm" @click.prevent="deleteAllCodes()">
                  <i class="fa fa-trash-o"></i> {{ $t('marketingCoupons.deleteAllCodes') }}
                </button>
                <button class="btn btn-purple btn-sm" :disabled="exporting" @click.prevent="exportCodes()">
                  <i class="fa fa-download"></i> {{ $t('marketingCoupons.export') }}
                </button>
              </div>
            </div>
            <div v-for="item in pagedCodes"
                 :key="item.index"
                 class="coupon-code-item"
                 :class="{'coupon-code-item--used': codeStatus(item.row) === 'used'}">
              <a v-if="codeQrUrl(item.row)"
                 :href="codeQrUrl(item.row)"
                 target="_blank"
                 class="coupon-code-item__qr"
                 :title="$t('marketingCoupons.openQr')">
                <img :src="codeQrUrl(item.row)" alt="QR">
              </a>
              <span v-else class="coupon-code-item__qr coupon-code-item__qr--empty"></span>
              <input type="text"
                     :placeholder="$t('marketingCampaigns.code')"
                     v-validate="modelValidations.coupons_codes.code"
                     v-model="item.row.code"
                     :disabled="item.row.used == 1"
                     class="form-control coupon-code-item__input">
              <span class="coupon-code-status" :class="'coupon-code-status--' + codeStatus(item.row)">
                {{ $t('marketingCoupons.codeStatus_' + codeStatus(item.row)) }}
              </span>
              <button class="btn btn-danger btn-icon" @click.prevent="deleteCode(item.index)"><i :title="$t('general.remove')" class="ti-close "></i></button>
            </div>
            <el-pagination
              v-if="activeCodes.length > codesPageSizes[0]"
              layout="sizes, prev, pager, next"
              :total="activeCodes.length"
              :page-sizes="codesPageSizes"
              :page-size="codesPageSize"
              :current-page.sync="codesPage"
              @size-change="onCodesPageSizeChange">
            </el-pagination>
            <small class="text-danger" v-if="errors.coupon_code">
              {{ $t('validations.requiredField') }}
            </small>
            <small class="text-danger" v-if="couponError">
              {{ couponError }}
            </small>
            <br v-if="couponError" />
            <button class="btn btn-icon btn-info" :disabled="model.type != 'COUPON'" @click.prevent="addNewCode()"><i class="ti-plus"></i></button>
          </div><br>



          <div class="form-group">
            <p-checkbox
              @input="clearCurrentInterval(coupons.use_time_interval)"
              key="interval"
              v-model="coupons.use_time_interval"
              :disabled="model.type != 'COUPON'"
              class="text-purple"
              label="">
            <h6 ref="interval" class="coupon-selection pad-to-7"  name="coupon_interval">{{$t('marketingCampaigns.useInterval')}}</h6>
            </p-checkbox>
            <small class="text-danger" v-if="errorInterval">
              {{ errorInterval }}
            </small>
          </div>

          <template v-if="coupons.use_time_interval">
            <div v-for="(interval, index) in coupons.interval_settings" class="form-group">
              <div  class="form-group">
                <label>{{$t('marketingCampaigns.chooseDayForInterval')}}</label>
                <v-select v-model="interval.day"
                                  :options="days"
                                  :disabled="model.type != 'COUPON'"
                                  :placeholder="$t('general.all')">
                </v-select>
              </div>
              <div  class="form-group" >
                <label>{{$t('marketingCampaigns.chooseHoursForInterval')}}</label>
                  <div class="campaign-forth-step-interval">
                    <div>
                      <el-time-select
                                      :placeholder="$t('general.from')"
                                      :disabled="model.type != 'COUPON'"
                                      v-model="interval.from"
                                      :name="'interval_from_' + index"
                                      data-vv-as="interval.from"
                                      v-validate="modelValidations.interval_settings.from"
                                      :picker-options="pickerOptions"
                                      :class="{ 'interval-field-error': errors.has('interval_from_' + index) }">
                      </el-time-select>
                      <small class="text-danger" style="display: block; margin-top: 4px;" v-if="errors.has('interval_from_' + index)">
                        {{ $t('validations.requiredField') }}
                      </small>
                    </div>
                    <div>
                      <el-time-select
                                      :placeholder="$t('general.to')"
                                      :disabled="model.type != 'COUPON'"
                                      v-model="interval.to"
                                      :name="'interval_to_' + index"
                                      data-vv-as="interval.to"
                                      v-validate="modelValidations.interval_settings.to"
                                      :picker-options="pickerOptions"
                                      :class="{ 'interval-field-error': errors.has('interval_to_' + index) }">
                      </el-time-select>
                      <small class="text-danger" style="display: block; margin-top: 4px;" v-if="errors.has('interval_to_' + index)">
                        {{ $t('validations.requiredField') }}
                      </small>
                    </div>
                    <div style="padding-top: 4px;">
                      <button class="btn btn-danger btn-icon pull-right" :disabled="model.type != 'COUPON'" @click.prevent="deleteInterval(index)"><i :title="$t('general.remove')" class="ti-close "></i></button>
                    </div>
                  </div>
              </div>
              <hr>
            </div>
            <div class="form-group">
              <button class="btn btn-icon btn-info" :disabled="model.type != 'COUPON'" @click.prevent="addNewInterval()" :title="$t('marketingCampaigns.addInterval')"><i class="ti-plus"></i></button>
            </div>
          </template>


          <div class="form-group">
            <label>{{$t('marketingCampaigns.counter_max_usage')}}</label>
            <input type="number"
                   :placeholder="$t('marketingCampaigns.counter_max_usage_example')"
                   v-validate="modelValidations.counter_max_usage"
                   v-model="coupons.counter_max_usage"
                   ref="couponCounterMaxUsage"
                   :disabled="model.type != 'COUPON' || coupons.coupon_has_multiple_codes || isSubscriptionCoupon || isAutomationCoupon"
                   class="form-control">
            <small class="text-danger" v-if="errors.counter_max_usage">
              {{ getError('counter_max_usage') }}
            </small>
          </div>
          <div class="form-group">
            <label>{{$t('marketingCampaigns.counter_max_usage_total')}}</label>
            <input type="number"
                   :placeholder="$t('marketingCampaigns.counter_max_usage_total_example')"
                   v-validate="modelValidations.counter_max_usage_total"
                   v-model="coupons.counter_max_usage_total"
                   ref="couponCounterMaxUsage"
                   :disabled="model.type != 'COUPON' || coupons.coupon_has_multiple_codes || isSubscriptionCoupon || isAutomationCoupon"
                   class="form-control">
            <small class="text-danger" v-if="errors.counter_max_usage_total">
              {{ getError('counter_max_usage_total') }}
            </small>
          </div>
          <div class="form-group">
            <label>{{$t('marketingCampaigns.delivery_methods')}}</label>
            <v-select v-model="coupons.delivery_methods"
                                  multiple
                                  :options="deliveryMethods"
                                  label="label"
                                  :disabled="model.type != 'COUPON'"
                                  :placeholder="$t('general.all')">
                      </v-select>
          </div>
          <div class="form-group">
            <label>{{$t('marketingCampaigns.order_source_ids')}}</label>
            <v-select :value="selectedOrderSources"
                      @input="onOrderSourcesChanged"
                      multiple
                      :options="orderSourceOptions"
                      label="label"
                      :disabled="!isCampaignModel || model.type != 'COUPON'"
                      :placeholder="$t('marketingCampaigns.order_source_ids_all')">
            </v-select>
            <small class="text-muted">{{ $t('marketingCampaigns.order_source_ids_help') }}</small>
          </div>
          <div class="form-group" v-if="locations.length > 1">
            <label>{{$t('marketingCampaigns.location_ids')}}</label>
            <v-select v-model="coupons.location_ids"
                                  multiple
                                  v-on:input="getCategories"
                                  :options="locations"
                                  label="name"
                                  :disabled="model.type != 'COUPON'"
                                  :placeholder="$t('general.all')">
                      </v-select>
          </div>
          <div class="form-group" >
            <label>{{$t('marketingFidelities.userLabeling')}}</label>
            <v-select
              v-model="coupons.user_label_selected"
              :options="userLabelLevels"
              label="label"
              :placeholder="$t('general.all')">
            </v-select>
          </div>
          <div class="form-group">
            <label class="control-label">{{$t('marketingCampaigns.groups')}}</label>
            <v-select
                    :placeholder="$t('general.all')"
                    multiple
                    :disabled="model.type != 'COUPON'"
                    :options="customerGroups"
                    label="name"
                    v-model="editableCustomerGroups"
                    >
            </v-select>
          </div>
          <div class="form-group">
            <label class="control-label">{{$t('marketingCampaigns.exclude_groups')}}</label>
            <v-select
                    :placeholder="$t('general.all')"
                    multiple
                    :options="customerGroups"
                    label="name"
                    v-model="coupons.excluding_group_customers"
                    >
            </v-select>
          </div>
        </div>
        <div class="col-md-6 icon-search" v-if="coupons.usage_type == 'PRODUCTS' && !isSpinningWheelFreeProductCoupon">
          <label>{{$t('marketingCampaigns.chooseCategProduct')}}*</label>
          <!-- <div class="check-all-products">
           <el-checkbox
              @change="checkAll($event)"
              v-model="checkProducts"
            >
              <span class="font-check-all-products"> {{$t('general.all')}}</span>
            </el-checkbox>
          </div> -->
          <el-tree
            v-loading="treeLoading"
            :empty-text="treeLoading ? ' ' : $t('marketingCoupons.noCategories')"
            :data="newCategories"
            :props="treeConfig"
            :check-strictly="false"
            :filter-node-method="filterNode"
            @node-expand="loadProducts"
            @check-change="validate"
            :default-checked-keys="checkedKeys"
            class="el-product-border filter-tree"
            node-key="id"
            ref="tree"
            show-checkbox
            accordion
            >
          </el-tree>
          <div class="buttons mar-to-5">
            <el-button @click="checkAll()">{{ $t('marketingCampaigns.checkAll') }}</el-button>
            <el-button @click="resetProductTree()">{{ $t('general.reset') }}</el-button>
          </div>
          <small class="text-danger" v-if="errorTree">
            {{ errorTree }}
          </small>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import Vue from 'vue'
  import { isSpinningWheelFreeProductCoupon } from '../spinningWheelCoupon'
  import {Radio, Checkbox, Tree} from 'element-ui'
  import {mapFields} from 'vee-validate'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import 'vue-tree-halower/dist/halower-tree.min.css' // you can customize the style of the tree
  // import VTree from 'vue-tree-halower'

  const ORDER_SOURCE_LABELS = {
    1: 'kiosk',
    2: 'qr',
    3: 'pos',
    4: 'app',
    5: 'website'
  }

  Vue.use(Checkbox)
  Vue.use(Radio)
  Vue.use(Tree)

  export default {
    props: {
      userLabelLevels: {
        type: [Object, Array],
        required: true
      },
      modelFromParent: {
        type: [Object, Array]
      },
      couponsParent: {
        type: [Object, Array],
        required: true
      },
      groupedProductsParent: {
        type: [Object, Array]
      },
      halfChecksProp: {
        type: [Object, Array]
      },
      couponError: {
        type: String,
        required: false
      },
      customerGroups: {
        type: [Object, Array]
      },
      selectedCustomerGroups: {
        type: [Object, Array, String],
        required: false
      },
      checkedKeys: {
        type: Array
      },
      route: {
        type: Object,
        default: () => ({})
      },
      // used outside the campaign wizard (Coupons tab): no "add coupon" checkbox, model = {type: 'COUPON', order_source_ids}
      standalone: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      filterText (val) {
        if (this.$refs.tree) this.$refs.tree.filter(val)
      },
      modelFromParent (value) {
        if (!value || Array.isArray(value) || typeof value !== 'object') {
          return
        }
        this.activeButton = value.type
        this.addcoupon = (value.type === 'COUPON')
        this.model = value
        this.normalizeModelOrderSourceIds()
        this.syncSelectedOrderSourcesFromModel()
      },
      'coupons.coupon_code' () {
        this.refreshSingleQr()
      },
      pagedCodes: {
        handler () {
          this.refreshPagedCodesQr()
        },
        deep: true
      },
      'coupons.coupon_has_multiple_codes' () {
        this.refreshSingleQr()
      },
      // subscription coupon (Coupons tab): no code, no auto apply / after first use, no multiple codes, no limits
      isSubscriptionCoupon (value) {
        if (!value) {
          return
        }
        this.coupons.auto_apply = false
        this.coupons.second_use_auto_coupon = false
        this.coupons.coupon_has_multiple_codes = false
        // always cumulative (applied together with the other coupons), not editable
        this.$set(this.coupons, 'is_cumulative', true)
        this.coupons.coupon_code = null
        this.coupons.counter_max_usage = null
        this.coupons.counter_max_usage_total = null
      },
      // automatic marketing coupon (Coupons tab): no auto apply / after first use, no multiple codes, no limits;
      // the single code stays: it is only informative for these coupons
      isAutomationCoupon (value) {
        if (!value) {
          return
        }
        this.coupons.auto_apply = false
        this.coupons.second_use_auto_coupon = false
        this.coupons.coupon_has_multiple_codes = false
        this.coupons.counter_max_usage = null
        this.coupons.counter_max_usage_total = null
      },
      couponsParent (value) {
        if (!value || Array.isArray(value)) {
          return
        }
        this.coupons = value
        this.seedCodeQrLinks()
        this.syncFreeProductSelection()
        this.coupons.user_label_selected = this.userLabelLevels.find(option => option.key === this.coupons.user_label_id)
      },
      // groupedProductsParent (value, oldVal) {
      //   this.groupedProducts = value
      //   this.getTrees()
      // },
      couponError () {
        if (this.couponError) {
          this.coupons.coupon_code = null
          this.validate()
        }
      },
      halfChecksProp (value) {
        this.halfChecks = value
      },
      'coupons.type' (value) {
        if (value === 'FREE_PRODUCT') {
          this.$nextTick(() => {
            this.syncFreeProductSelection()
          })
        }
      }
    },
    computed: {
      ...mapFields(['firstName', 'lastName', 'email']),
      isSubscriptionCoupon () {
        return !!(this.coupons && this.coupons.is_subscription)
      },
      isAutomationCoupon () {
        return !!(this.coupons && this.coupons.is_automation)
      },
      automationCodeValidation () {
        return this.modelValidations.automationCodeValidation
      },
      isSpinningWheelFreeProductCoupon () {
        return isSpinningWheelFreeProductCoupon(this.coupons, this.model)
      },
      isFreeProductCoupon () {
        return this.coupons.type === 'FREE_PRODUCT'
      },
      // not deleted entries of the multiple codes list, with their index in coupons.coupons_codes
      activeCodes () {
        return (this.coupons.coupons_codes || [])
          .map((row, index) => ({row, index}))
          .filter(item => !item.row.delete)
      },
      pagedCodes () {
        const start = (this.codesPage - 1) * this.codesPageSize
        return this.activeCodes.slice(start, start + this.codesPageSize)
      },
      generatorExample () {
        const alphabets = {
          alnum: 'ABCDEFGHJKMNPQRSTUVWXYZ23456789',
          letters: 'ABCDEFGHJKMNPQRSTUVWXYZ',
          digits: '0123456789'
        }
        const alphabet = alphabets[this.generator.charset] || alphabets.alnum
        const length = Math.min(Math.max(parseInt(this.generator.length, 10) || 8, 4), 20)
        let random = ''
        for (let i = 0; i < length; i++) {
          random += alphabet[(i * 7 + 3) % alphabet.length]
        }
        const group = parseInt(this.generator.group, 10) || 0
        if (group > 0) {
          random = random.match(new RegExp('.{1,' + group + '}', 'g')).join('-')
        }
        return (this.generator.prefix || '').toUpperCase() + random + (this.generator.suffix || '').toUpperCase()
      },
      isCampaignModel () {
        return this.model && !Array.isArray(this.model) && typeof this.model === 'object'
      },
      editableCustomerGroups: {
        get () {
          return this.selectedCustomerGroups
        },
        set (val) {
          this.$emit('groupCustomers', val)
        }
      },
      orderSourceOptions () {
        return Object.keys(ORDER_SOURCE_LABELS).map(id => ({
          id: parseInt(id, 10),
          label: this.orderSourceLabel(ORDER_SOURCE_LABELS[id], id)
        }))
      }
    },
    mounted () {
      this.$validator.extend('customConditionCouponValue', (value) => {
        let required = true
        let valid = true
        if (this.isFreeProductCoupon) {
          return { valid: true, data: { required: false } }
        }
        if (this.coupons.type === 'PERCENTAGE') {
          if (value > 100) {
            valid = false
          }
        }
        if (parseInt(value) <= 0) {
          valid = false
        }
        if (this.model.is_waterfall) {
          valid = true
        }
        return {
          'error-messages': ['aaaaaaaaaaaaaaaaa'],
          valid, // or false
          data: {
            required, // or false
            message: 'Not this value'
          }
        }
      },
        {
          computesRequired: true
        })
      this.$validator.extend('customCondition', (value) => {
        let required = true
        let valid = true
        if (this.coupons.type === 'PERCENTAGE') {
          if (value > 100) {
            valid = false
          }
        }
        if (parseInt(value) <= 0) {
          valid = false
        }
        return {
          'error-messages': ['aaaaaaaaaaaaaaaaa'],
          valid, // or false
          data: {
            required, // or false
            message: 'Not this value'
          }
        }
      },
        {
          computesRequired: true
        })
    },
    created () {
      this.onCreatedGetUserLabeling()
      this.loadDefaultFreeProducts()
      if (this.isCampaignModel) {
        this.normalizeModelOrderSourceIds()
        this.syncSelectedOrderSourcesFromModel()
      }
      if (!this.coupons.from_value) {
        this.coupons.from_value = 0
      }
      this.seedCodeQrLinks()
      this.singleQrUrl = this.coupons.qr_url || null
      if (!this.singleQrUrl) {
        this.refreshSingleQr()
      }
      this.$nextTick(() => {
        this.getCategories()
      })
    },
    data () {
      return {
        importedCodes: '',
        newCategories: [],
        treeLoading: false,
        singleQrUrl: null,
        singleQrTimer: null,
        exporting: false,
        generating: false,
        generatorError: null,
        generator: {
          count: 100,
          length: 8,
          charset: 'alnum',
          prefix: '',
          suffix: '',
          group: 0
        },
        // QR links of the codes in the list, keyed by code (saved codes come with qr_url, the others are fetched)
        codeQrLinks: {},
        codeQrTimer: null,
        codesPage: 1,
        codesPageSize: 25,
        codesPageSizes: [25, 50, 100],
        filterText: '',
        expand: [],
        model: this.value || this.modelFromParent,
        groupedProducts: this.value || this.groupedProductsParent,
        customCondition: {},
        customConditionCouponValue: {},
        modelValidations: {
          coupons_codes: {
            code: {
              required: true,
              min: 4
            }
          },
          from_value: {
            required: true,
            min_value: 0
          },
          type: {
            required: true
          },
          usage_type: {
            required: true
          },
          discount: {
            required: true,
            min_value: 1
          },
          coupon_code: {
            required: true,
            min: 4
          },
          // automatic marketing coupon: the informative code is optional
          automationCodeValidation: {
            min: 4
          },
          counter_max_usage: {
            required: true,
            min: 0
          },
          counter_max_usage_total: {
            required: true,
            min: 0
          },
          interval_settings: {
            from: {
              required: true
            },
            to: {
              required: true
            }
          }
        },
        coupons: this.value || this.couponsParent,
        couponType: this.$session.get('defaultData')['coupons_types'],
        couponUsageTypes: this.$session.get('defaultData')['coupons_usage_types'],
        pickerOptions1: {},
        pickerNames: ['date_from', 'date_to'],
        searchword: '',
        activeButton: 0,
        addcoupon: false,
        treeData: [],
        currency: '',
        deliveryMethods: [],
        locations: [],
        intervals: [],
        errorInterval: null,
        errorTree: null,
        errorFreeProduct: null,
        freeProducts: [],
        selectedFreeProduct: null,
        loadingFreeProducts: false,
        freeProductSearchTimer: null,
        intervalDays: [],
        pickerOptions: {
          start: '00:00',
          step: '00:15',
          end: '24:00'
        },
        days: [
          {
            key: 'monday',
            label: this.$t('days.monday')
          },
          {
            key: 'tuesday',
            label: this.$t('days.tuesday')
          },
          {
            key: 'wednesday',
            label: this.$t('days.wednesday')
          },
          {
            key: 'thursday',
            label: this.$t('days.thursday')
          },
          {
            key: 'friday',
            label: this.$t('days.friday')
          },
          {
            key: 'saturday',
            label: this.$t('days.saturday')
          },
          {
            key: 'sunday',
            label: this.$t('days.sunday')
          }
        ],
        checkProducts: false,
        halfChecks: [],
        selectedOrderSources: [],
        treeConfig: {
          id: 'id',
          label: 'name',
          isLeaf: 'leaf',
          level: 'level',
          children: 'children',
          loading: false,
          loadedOnce: false
        }
      }
    },
    methods: {
      orderSourceLabel (label, orderSourceId) {
        const resolvedLabel = label || ORDER_SOURCE_LABELS[orderSourceId]
        if (!resolvedLabel) {
          return ''
        }
        const key = 'orderFrom.' + resolvedLabel
        const translated = this.$t(key)
        if (translated !== key) {
          return translated
        }
        const upperKey = 'orderFrom.' + String(resolvedLabel).toUpperCase()
        const upperTranslated = this.$t(upperKey)
        return upperTranslated !== upperKey ? upperTranslated : resolvedLabel
      },
      normalizeModelOrderSourceIds () {
        if (!this.isCampaignModel) {
          return
        }
        const raw = this.model.order_source_ids
        if (raw == null || raw === '') {
          this.$set(this.model, 'order_source_ids', [])
          return
        }
        let ids = raw
        if (typeof raw === 'string') {
          try {
            ids = JSON.parse(raw)
          } catch (e) {
            ids = []
          }
        }
        if (!Array.isArray(ids)) {
          this.$set(this.model, 'order_source_ids', [])
          return
        }
        this.$set(
          this.model,
          'order_source_ids',
          ids.map(id => parseInt(id, 10)).filter(id => !isNaN(id))
        )
      },
      syncSelectedOrderSourcesFromModel () {
        if (!this.isCampaignModel) {
          this.selectedOrderSources = []
          return
        }
        const ids = this.model.order_source_ids
        if (!Array.isArray(ids) || !ids.length) {
          this.selectedOrderSources = []
          return
        }
        const normalizedIds = ids.map(id => parseInt(id, 10)).filter(id => !isNaN(id))
        this.selectedOrderSources = this.orderSourceOptions.filter(option =>
          normalizedIds.includes(option.id)
        )
      },
      onOrderSourcesChanged (value) {
        this.selectedOrderSources = value || []
        if (!this.isCampaignModel) {
          return
        }
        this.$set(
          this.model,
          'order_source_ids',
          this.selectedOrderSources.map(option => option.id)
        )
      },
      importCodes () {
        let arrayCodes = this.importedCodes.split(/[\s,;]+/).filter(code => code !== '')
        this.importedCodes = ''
        arrayCodes.forEach((code) => {
          this.coupons.coupons_codes.push({'code': code})
        })
      },
      requestData () {
        return {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
      },
      // QR of the single code (signed public link from the API, works before saving too)
      refreshSingleQr () {
        clearTimeout(this.singleQrTimer)
        const code = (this.coupons.coupon_code || '').trim()
        if (this.coupons.coupon_has_multiple_codes || !code) {
          this.singleQrUrl = null
          return
        }
        this.singleQrTimer = setTimeout(() => {
          this.apiRequest('/coupon/qr-links', 'POST', {...this.requestData(), codes: [code]}, (response) => {
            if (response.status === true && response.data.length && (this.coupons.coupon_code || '').trim() === code) {
              this.singleQrUrl = response.data[0].qr_url
            }
          })
        }, 400)
      },
      generateCodes () {
        this.generatorError = null
        this.generating = true
        const data = {
          ...this.requestData(),
          ...this.generator,
          exclude: this.activeCodes.map(item => item.row.code)
        }
        this.apiRequest('/coupon/generate-codes', 'POST', data, (response) => {
          this.generating = false
          if (response.status !== true) {
            const errors = response.errors || {}
            const first = Object.keys(errors).map(key => Array.isArray(errors[key]) ? errors[key][0] : errors[key])[0]
            this.generatorError = first || this.$t('validations.wentWrong')
            return
          }
          const codes = response.data.codes || []
          if (!Array.isArray(this.coupons.coupons_codes)) {
            this.$set(this.coupons, 'coupons_codes', [])
          }
          codes.forEach(code => this.coupons.coupons_codes.push({code: code}))
          this.codesPage = Math.max(1, Math.ceil(this.activeCodes.length / this.codesPageSize))
          this.$notify({
            message: this.$t('marketingCoupons.generatedCodes', {count: codes.length}),
            type: 'success'
          })
        })
      },
      // CSV: code + QR image link (+ used for multiple codes)
      exportCodes () {
        const multiple = !!this.coupons.coupon_has_multiple_codes
        const rows = multiple
          ? this.activeCodes.map(item => item.row).filter(row => (row.code || '').trim() !== '')
          : [{code: (this.coupons.coupon_code || '').trim()}].filter(row => row.code !== '')
        if (!rows.length) {
          return
        }
        this.exporting = true
        this.apiRequest('/coupon/qr-links', 'POST', {...this.requestData(), codes: rows.map(row => row.code.trim())}, (response) => {
          this.exporting = false
          if (response.status !== true) {
            this.$notify({message: this.$t('validations.wentWrong'), type: 'danger'})
            return
          }
          const linkByCode = {}
          response.data.forEach(item => { linkByCode[item.code] = item.qr_url })
          const quote = value => '"' + String(value == null ? '' : value).replace(/"/g, '""') + '"'
          const header = [this.$t('marketingCoupons.code'), this.$t('marketingCoupons.qrLink')]
          if (multiple) {
            header.push(this.$t('marketingCoupons.used'))
          }
          const lines = [header.map(quote).join(';')]
          rows.forEach(row => {
            const line = [row.code.trim(), linkByCode[row.code.trim()] || '']
            if (multiple) {
              line.push(parseInt(row.used, 10) === 1 ? this.$t('general.yes') : this.$t('general.no'))
            }
            lines.push(line.map(quote).join(';'))
          })
          // BOM => Excel opens the file as UTF-8
          const blob = new Blob(['\ufeff' + lines.join('\r\n')], {type: 'text/csv;charset=utf-8'})
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          const name = String(this.coupons.name || this.coupons.coupon_code || 'cupon').replace(/[^a-zA-Z0-9-_]+/g, '_')
          a.href = url
          a.download = 'coduri-' + name + '.csv'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          window.URL.revokeObjectURL(url)
        })
      },
      checkAll () {
        const nodes = this.$refs.tree.store.root.childNodes // Get all top-level nodes
        const checkedKeys = nodes.map(node => node.key) // Get the key of each top-level node
        this.$refs.tree.setCheckedKeys(checkedKeys) // Set the checked keys
      },
      resetProductTree () {
        this.$refs.tree.setCheckedKeys([])
      },
      loadProducts (node) {
        let treeNode = this.$refs.tree.getNode(node)
        let locationIds = []
        if (this.coupons['location_ids']) {
          locationIds = this.coupons['location_ids'].map(loc => loc.id)
        }
        if (!this.expand.includes(node.id) && !node.loadedOnce) {
          var data = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            category_id: parseInt(node.id),
            location_ids: locationIds
          }
          node.loading = true
          this.apiRequest('/product-tree-products', 'GET', data, (response) => {
            if (response.status) {
              node.children = response.data
              node.expand = true
              node.loading = false
              node.loadedOnce = true
              this.$nextTick(() => {
                if (treeNode.checked) {
                  this.$refs.tree.setCheckedNodes(this.$refs.tree.getCheckedNodes().concat(treeNode.children))
                }
              })
            }
          })
        }
      },
      filterNode (value, data) {
        if (!value) return true
        // search node label
        if (data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1) {
          return true
        }
        // search children labels recursively
        if (data.children) {
          for (let i = 0; i < data.children.length; i++) {
            if (this.filterNode(value, data.children[i])) {
              return true
            }
          }
        }
        return false
      },
      loadNode (node, resolve) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          category_id: parseInt(node.data.id),
          category_name: node.data.name
        }
        this.apiRequest('/product-tree-category-products', 'GET', data, (response) => {
          if (response.status) {
            resolve(response.data.products)
          }
        })
      },
      getCategories () {
        let locationIds = []
        if (this.coupons['location_ids']) {
          locationIds = this.coupons['location_ids'].map(loc => loc.id)
        }
        const groupData = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          usage_for_products: this.coupons['usage_for_products'],
          usage_for_categories: this.coupons['usage_for_categories'],
          location_ids: locationIds
        }
        if (this.standalone) {
          if (this.coupons && this.coupons.id) {
            groupData.coupon_id = this.coupons.id
          }
        } else if (this.route.params.id) {
          groupData.campaign_id = this.route.params.id
        }
        if (this.coupons && this.coupons.location_ids) {
          let locationIds = []
          for (let loc of this.coupons.location_ids) {
            locationIds.push(loc.id)
          }
          groupData.location_ids = locationIds
        }
        this.treeLoading = true
        this.apiRequest('/get-tree', 'GET', groupData, (response) => {
          this.treeLoading = false
          if (response.status === true) {
            this.newCategories = response.data.tree
            this.expand = Object.values(response.data.expand)
          }
        })
      },
      onCreatedGetUserLabeling () {
        this.currency = this.getCurrencySymbol(this.$session.get('selectedCompanyData').currency_iso)
        this.deliveryMethods = this.getCompanyDetail('delivery_options_labels')
        this.locations = this.getCompanyDetail('locations_details')
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.errors.clear()
        this.errorTree = null
        this.errorFreeProduct = null

        if (this.isFreeProductCoupon && !this.coupons.free_product_id) {
          this.errorFreeProduct = this.$t('marketingCampaigns.freeProductRequired')
          return false
        }

        if (this.coupons.use_time_interval) {
          if (this.coupons.interval_settings === undefined || this.coupons.interval_settings === '' || this.coupons.interval_settings === null || this.coupons.interval_settings.length === 0) {
            this.errorInterval = this.$t('marketingCampaigns.intervalMustBeSet')
            return false
          }
          for (let i = 0; i < this.coupons.interval_settings.length; i++) {
            const interval = this.coupons.interval_settings[i]
            if (!interval.from || interval.from === '') {
              this.errors.add('interval_from_' + i, this.$t('validations.requiredField'))
            }
            if (!interval.to || interval.to === '') {
              this.errors.add('interval_to_' + i, this.$t('validations.requiredField'))
            }
          }
          if (this.errors.items.some(item => item.field.startsWith('interval_from_') || item.field.startsWith('interval_to_'))) {
            return false
          }
        }

        if (this.coupons['usage_type'] === 'PRODUCTS' && !this.isSpinningWheelFreeProductCoupon) {
          let checkedKeys = this.$refs.tree.getCheckedKeys()
          if (checkedKeys.length === 0) {
            this.errorTree = this.$t('marketingCampaigns.productTreeError')
            return false
          } else {
            this.errorTree = null
            return true
          }
        }
        return this.$validator.validateAll()
      },
      loadDefaultFreeProducts () {
        this.searchFreeProducts('', true)
      },
      searchFreeProducts (search, immediate = false) {
        if (this.freeProductSearchTimer) {
          clearTimeout(this.freeProductSearchTimer)
          this.freeProductSearchTimer = null
        }

        const query = (search || '').trim()
        const delay = immediate ? 0 : 300

        this.freeProductSearchTimer = setTimeout(() => {
          const data = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany')
          }

          if (query) {
            data.search = query
          }

          if (this.coupons && Array.isArray(this.coupons.location_ids) && this.coupons.location_ids.length === 1) {
            const location = this.coupons.location_ids[0]
            data.location_id = location.id || location.true_id || location
          }

          this.loadingFreeProducts = true
          this.apiRequest('/search-order-products', 'GET', data, (response) => {
            if (response.status === true) {
              const options = (response.data || []).map(product => this.mapFreeProductOption(product))
              if (this.selectedFreeProduct && !options.find(option => parseInt(option.id, 10) === parseInt(this.selectedFreeProduct.id, 10))) {
                options.unshift(this.selectedFreeProduct)
              }
              this.freeProducts = options
              this.syncFreeProductSelection()
            }
            this.$nextTick(() => {
              this.loadingFreeProducts = false
            })
          })
        }, delay)
      },
      mapFreeProductOption (product) {
        const id = parseInt(product.product_id || product.id, 10)
        return {
          id,
          name: product.name || product.label || ('Product #' + id)
        }
      },
      findFreeProductOption (id) {
        const normalizedId = parseInt(id, 10)
        if (isNaN(normalizedId)) {
          return null
        }
        return this.freeProducts.find(product => parseInt(product.id, 10) === normalizedId) || null
      },
      onFreeProductSelected (product) {
        this.selectedFreeProduct = product
        this.coupons.free_product_id = product ? parseInt(product.id, 10) : null
      },
      getFreeProductNameFromRelation () {
        const relation = this.coupons.free_product
        if (relation && relation.name) {
          return relation.name
        }
        const value = this.coupons.free_product_id
        if (value && typeof value === 'object' && value.name) {
          return value.name
        }
        return null
      },
      upsertFreeProductOption (id, name) {
        const normalizedId = parseInt(id, 10)
        if (isNaN(normalizedId)) {
          return null
        }
        const existingIndex = this.freeProducts.findIndex(product => parseInt(product.id, 10) === normalizedId)
        const option = {
          id: normalizedId,
          name: name || ('Product #' + normalizedId)
        }
        if (existingIndex === -1) {
          this.freeProducts.unshift(option)
        } else if (name) {
          this.$set(this.freeProducts, existingIndex, option)
        }
        return this.findFreeProductOption(normalizedId)
      },
      syncFreeProductSelection () {
        const id = this.normalizeFreeProductId(this.coupons.free_product_id)
        if (id == null) {
          this.selectedFreeProduct = null
          return
        }

        this.coupons.free_product_id = id
        const relationName = this.getFreeProductNameFromRelation()
        let option = this.findFreeProductOption(id)

        if (option && relationName && option.name !== relationName) {
          option = this.upsertFreeProductOption(id, relationName)
        }

        if (option) {
          this.selectedFreeProduct = option
          return
        }

        if (relationName) {
          this.selectedFreeProduct = this.upsertFreeProductOption(id, relationName)
          return
        }

        this.fetchMissingFreeProductName(id)
      },
      fetchMissingFreeProductName (id) {
        const normalizedId = parseInt(id, 10)
        if (isNaN(normalizedId)) {
          return
        }

        const existing = this.findFreeProductOption(normalizedId)
        if (existing) {
          this.selectedFreeProduct = existing
          return
        }

        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          search: String(normalizedId)
        }
        this.apiRequest('/search-order-products', 'GET', data, (response) => {
          let product = null
          if (response && response.status === true && Array.isArray(response.data)) {
            product = response.data.find(item => parseInt(item.id || item.product_id, 10) === normalizedId) || response.data[0]
          }
          if (product) {
            const option = this.upsertFreeProductOption(
              normalizedId,
              product.name || product.label
            )
            this.selectedFreeProduct = option
            this.coupons.free_product_id = normalizedId
            return
          }

          // Fallback for edit mode when search does not return the saved product
          this.apiRequest('/product/' + normalizedId, 'GET', {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany')
          }, (productResponse) => {
            let fallbackProduct = null
            if (productResponse && productResponse.status === true && productResponse.data) {
              fallbackProduct = Array.isArray(productResponse.data) ? productResponse.data[0] : productResponse.data
            }
            if (fallbackProduct && fallbackProduct.name) {
              const option = this.upsertFreeProductOption(normalizedId, fallbackProduct.name)
              this.selectedFreeProduct = option
              this.coupons.free_product_id = normalizedId
            }
          })
        })
      },
      normalizeFreeProductId (value) {
        if (value == null || value === '') {
          return null
        }
        if (typeof value === 'object') {
          const id = value.product_id || value.id
          return id != null ? parseInt(id, 10) : null
        }
        const parsed = parseInt(value, 10)
        return isNaN(parsed) ? null : parsed
      },
      handleIntervalErrors (errors) {
        Object.keys(errors).forEach(errorKey => {
          if (errorKey.startsWith('interval_settings.')) {
            const match = errorKey.match(/interval_settings\.(\d+)\.(from|to)/)
            if (match) {
              const index = match[1]
              const field = match[2]
              const fieldName = 'interval_' + field + '_' + index
              this.errors.add(fieldName, this.$t('validations.requiredField'))
            }
          }
        })
      },
      changeType () {
        let newType = 'TEXT'
        if (this.addcoupon) {
          newType = 'COUPON'
          // this.getTrees()
        }
        if (newType === 'TEXT') {
          this.errorInterval = null
          this.coupons.use_time_interval = false
        }
        this.model['type'] = newType
        this.activeButton = newType
        this.getCategories()
      },
      // search () {
      //   var data = {
      //     token: this.$session.get('token'),
      //     company_id: this.$session.get('selectedCompany')
      //   }
      //   if (this.coupons && this.coupons.location_ids) {
      //     let locationIds = []
      //     for (let loc of this.coupons.location_ids) {
      //       locationIds.push(loc.id)
      //     }
      //     data.location_ids = locationIds
      //   }

      //   if (this.searchword.length >= 3) {
      //     data.search = this.searchword
      //     this.apiRequest('/product-tree-search', 'GET', data, (response) => {
      //       if (response.status === true) {
      //         this.groupedProducts = response.data
      //         this.getTrees()
      //       }
      //     })
      //   }

      //   if (this.searchword.length === 0) {
      //     data.usage_for_products = this.coupons['usage_for_products']
      //     this.apiRequest('/product-tree-categories', 'GET', data, (response) => {
      //       if (response.status === true) {
      //         this.groupedProducts = response.data.data
      //         this.getTrees()
      //       }
      //     })
      //   }
      // },
      generateCode () {
        if (this.coupons['type'] === undefined) {
          this.coupons['type'] = 'PERCENTAGE'
        }
        this.apiRequest('/coupon/generate-codes', 'POST', {...this.requestData(), count: 1, length: 8}, (response) => {
          const code = response.status === true && response.data.codes && response.data.codes[0]
          this.coupons['coupon_code'] = code || Math.random().toString(36).substring(7).toUpperCase()
        })
      },
      // getTrees (expendNodeId = null, expandParam = null) {
      //   this.$nextTick(function () {
      //     var catProdTree = []
      //     this.treeData = []
      //     let expand = false

      //     for (var id in this.groupedProducts) {
      //       if (expendNodeId && parseInt(expendNodeId) === parseInt(id)) {
      //         if (expandParam) {
      //           expand = expandParam
      //         }
      //       } else {
      //         expand = false
      //       }
      //       let idCateg = this.isInObject(parseInt(id), this.coupons.usage_for_categories)
      //       if (idCateg) {
      //         let data = {'id': id, 'label': this.groupedProducts[id].details.name, 'checked': true}
      //         let children = []
      //         for (let idx in this.groupedProducts[id].items) {
      //           let title = this.groupedProducts[id].items[idx].name
      //           title += this.groupedProducts[id].items[idx].locations.length !== 0 ? ' (' + Object.values(this.groupedProducts[id].items[idx].locations) + ')' : ' (' + this.$t('general.all') + ')'
      //           children.push({'id': this.groupedProducts[id].items[idx].id, 'text': title, 'checked': true})
      //         }
      //         data['children'] = children
      //         data['expanded'] = expand
      //         catProdTree.push(data)
      //       } else {
      //         // handle children
      //         let children = []
      //         for (let idx in this.groupedProducts[id].items) {
      //           let chk = false
      //           let idProd = this.isInObject(parseInt(this.groupedProducts[id].items[idx].id), this.coupons.usage_for_products)
      //           if (idProd) {
      //             chk = true
      //           }
      //           let title = this.groupedProducts[id].items[idx].name
      //           title += this.groupedProducts[id].items[idx].locations.length !== 0 ? ' (' + Object.values(this.groupedProducts[id].items[idx].locations) + ')' : ' (' + this.$t('general.all') + ')'
      //           children.push({
      //             'id': this.groupedProducts[id].items[idx].id,
      //             'title': title,
      //             'checked': chk
      //           })
      //         }
      //         let isHalfcheck = false
      //         if (this.halfChecks.length && this.halfChecks.includes(parseInt(id))) {
      //           isHalfcheck = true
      //         }
      //         catProdTree.push({'id': id, 'title': this.groupedProducts[id].details.name, 'expanded': expand, 'children': children, 'halfcheck': isHalfcheck, 'checked': false})
      //       }
      //     }
      //     this.treeData = catProdTree
      //   })
      // },
      // checkAll (event) {
      //   if (event) {
      //     const nodes = this.$refs.tree.store.root.childNodes // Get all top-level nodes
      //     const checkedKeys = nodes.map(node => node.key) // Get the key of each top-level node
      //     this.$refs.tree.setCheckedKeys(checkedKeys) // Set the checked keys
      //   } else {
      //     this.$refs.tree.setCheckedKeys([])
      //   }

        // const nodes = this.$refs.tree
        // const checkedNodes = this.$refs.tree.getNodes()
        // const level1Nodes = checkedNodes.filter(node => node.level === 1)
        // const level2Nodes = checkedNodes.filter(node => node.level === 2)
        // console.log(checkedNodes)
        // console.log('lvl 1 ')
        // console.log(nodes.data)
        // let treeNoideIds = nodes.data.map(node => {
        //   return node.$treeNodeId
        // })
        // this.$refs.tree.setCheckedKeys(treeNoideIds)
        // console.log(treeNoideIds)
        // console.log('lvl 2 ')
        // console.log(level2Nodes)
        // if (event) {
        //   this.coupons['usage_for_categories'] = []
        //   for (const item of this.treeData) {
        //     this.coupons['usage_for_categories'].push(item.id)
        //   }
        // } else {
        //   this.coupons['usage_for_categories'] = []
        //   this.coupons['usage_for_products'] = []
        //   this.halfChecks = []
        // }
        // this.getTrees()
      // },
      // areAllChecked (curentDataTree) {
      //   let flagIsChecked = false
      //   for (const item of curentDataTree) {
      //     if (item.checked) {
      //       flagIsChecked = true
      //     } else {
      //       return false
      //     }
      //   }
      //   return flagIsChecked
      // },
      // removeChildrenFromUsageForProducts (node) {
      //   for (const child of node.children) {
      //     if (this.coupons['usage_for_products'].includes(child.id)) {
      //       let index = this.coupons['usage_for_products'].indexOf(child.id)
      //       this.coupons['usage_for_products'].splice(index, 1)
      //     }
      //   }
      // },
      // updateCouponUsage (node, checked, position) {
      //   if (position.level === 1) {
      //     if (!checked && this.coupons['usage_for_categories'].includes(parseInt(node.id))) {
      //       let index = this.coupons['usage_for_categories'].indexOf(parseInt(node.id))
      //       this.coupons['usage_for_categories'].splice(index, 1)
      //     }
      //     if (checked && !this.coupons['usage_for_categories'].includes(parseInt(node.id))) {
      //       this.coupons['usage_for_categories'].push(parseInt(node.id))
      //     }
      //     if (!checked && this.halfChecks.includes(parseInt(node.id))) {
      //       let index = this.halfChecks.indexOf(parseInt(node.id))
      //       this.halfChecks.splice(index, 1)
      //       if (!node.children.length) {
      //         var data = {
      //           token: this.$session.get('token'),
      //           company_id: this.$session.get('selectedCompany'),
      //           category_id: parseInt(node.id),
      //           category_name: node.title
      //         }

      //         if (this.searchword.length >= 3) {
      //           data.search = this.searchword
      //         }
      //         if (this.coupons && this.coupons.location_ids) {
      //           let locationIds = []
      //           for (let loc of this.coupons.location_ids) {
      //             locationIds.push(loc.id)
      //           }
      //           // this.coupons['usage_for_products'] = []
      //           data.location_ids = locationIds
      //         }
      //         this.apiRequest('/product-tree-category-products', 'GET', data, (response) => {
      //           if (response.status) {
      //             node.children = response.data.products
      //             this.removeChildrenFromUsageForProducts(node)
      //             this.getTrees()
      //           }
      //         })
      //       } else {
      //         this.removeChildrenFromUsageForProducts(node)
      //       }
      //     }
      //   }

      //   if (position.level === 2) {
      //     let checkedChildren = []
      //     for (const child of node.parent().children) {
      //       if (child.checked) {
      //         checkedChildren.push(child.id)
      //       }
      //     }

      //     if (!checked && this.coupons['usage_for_products'].includes(node.id)) {
      //       let index = this.coupons['usage_for_products'].indexOf(node.id)
      //       this.coupons['usage_for_products'].splice(index, 1)
      //     }

      //     if (checked && !this.coupons['usage_for_products'].includes(node.id)) {
      //       this.coupons['usage_for_products'].push(node.id)
      //       let parentId = parseInt(node.parent().id)
      //       if (!this.halfChecks.includes(parentId)) {
      //         this.halfChecks.push(parentId)
      //       }
      //     }

      //     if (node.parent().children.length === checkedChildren.length && this.searchword.length < 3) {
      //       if (!this.coupons['usage_for_categories'].includes(parseInt(node.parent().id))) {
      //         this.coupons['usage_for_categories'].push(parseInt(node.parent().id))
      //       }

      //       for (const child of node.parent().children) {
      //         let index = this.coupons['usage_for_products'].indexOf(child.id)
      //         this.coupons['usage_for_products'].splice(index, 1)
      //       }

      //       let index = this.coupons['usage_for_products'].indexOf(node.id)
      //       this.coupons['usage_for_products'].splice(index, 1)
      //     } else if (node.parent().children.length - 1 === checkedChildren.length && checked === false) {
      //       let indexParent = this.coupons['usage_for_categories'].indexOf(parseInt(node.parent().id))
      //       this.coupons['usage_for_categories'].splice(indexParent, 1)

      //       let children = node.parent().children
      //       let otherChildrenIds = []
      //       children.forEach((child) => {
      //         if (child.id !== node.id) {
      //           otherChildrenIds.push(child.id)
      //         }
      //       })
      //       let usageForProducts = this.coupons['usage_for_products']
      //       this.coupons['usage_for_products'] = usageForProducts.concat(otherChildrenIds)
      //     }
      //   }
      // },
      // getProductsForCategory (node, expand, position) {
      //   if (!node.children.length) {
      //     var data = {
      //       token: this.$session.get('token'),
      //       company_id: this.$session.get('selectedCompany'),
      //       category_id: parseInt(node.id),
      //       category_name: node.title
      //     }

      //     if (this.searchword.length >= 3) {
      //       data.search = this.searchword
      //     }
      //     if (this.coupons && this.coupons.location_ids) {
      //       let locationIds = []
      //       for (let loc of this.coupons.location_ids) {
      //         locationIds.push(loc.id)
      //       }
      //       // this.coupons['usage_for_products'] = []
      //       data.location_ids = locationIds
      //     }
      //     this.apiRequest('/product-tree-category-products', 'GET', data, (response) => {
      //       if (response.status) {
      //         let categoryId = response.data.category_id
      //         this.groupedProducts[categoryId].items = response.data.products
      //         this.getTrees(categoryId, expand)
      //       }
      //     })
      //   } else {
      //     for (var index = 0; index < this.treeData.length; index++) {
      //       this.treeData[index].expanded = false
      //       this.treeData[index].hasExpanded = false
      //     }
      //     this.treeData[position.index].expanded = expand
      //     this.treeData[position.index].hasExpanded = expand
      //   }
      // },
      addNewInterval () {
        this.errorInterval = null
        let newRow = {
          'day': '',
          'from': '',
          'to': ''
        }
        this.coupons.interval_settings.push(newRow)
      },
      deleteInterval (index) {
        this.coupons.interval_settings.splice(index, 1)
      },
      addNewCode () {
        this.errorCode = null
        let newRow = {
          'code': ''
        }
        this.coupons.coupons_codes.push(newRow)
      },
      codeStatus (row) {
        if (parseInt(row.used, 10) === 1) {
          return 'used'
        }
        return row.id ? 'available' : 'new'
      },
      codeQrUrl (row) {
        const code = (row.code || '').trim()
        return code ? this.codeQrLinks[code] || null : null
      },
      seedCodeQrLinks () {
        (this.coupons.coupons_codes || []).forEach(row => {
          if (row.qr_url && row.code) {
            this.$set(this.codeQrLinks, row.code.trim(), row.qr_url)
          }
        })
      },
      // QR links only for the codes of the current page that do not have one yet
      refreshPagedCodesQr () {
        clearTimeout(this.codeQrTimer)
        this.codeQrTimer = setTimeout(() => {
          const missing = [...new Set(this.pagedCodes
            .map(item => (item.row.code || '').trim())
            .filter(code => code !== '' && !this.codeQrLinks[code]))]
          if (!missing.length) {
            return
          }
          this.apiRequest('/coupon/qr-links', 'POST', {...this.requestData(), codes: missing}, (response) => {
            if (response.status === true) {
              response.data.forEach(item => this.$set(this.codeQrLinks, item.code, item.qr_url))
            }
          })
        }, 400)
      },
      onCodesPageSizeChange (size) {
        this.codesPageSize = size
        this.codesPage = 1
      },
      // saved codes are marked as deleted (removed on save, like the X button), unsaved ones are dropped
      deleteAllCodes () {
        swal({
          text: this.$t('marketingCoupons.deleteAllCodesConfirm', {count: this.activeCodes.length}),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        }).then((result) => {
          if (!result) {
            return
          }
          this.coupons.coupons_codes = (this.coupons.coupons_codes || [])
            .filter(row => row.id)
            .map(row => ({...row, delete: true}))
          this.codesPage = 1
        }).catch(() => {})
      },
      deleteCode (index) {
        let cv = this.coupons.coupons_codes
        this.coupons.coupons_codes = []
        cv[index].delete = true
        this.coupons.coupons_codes = cv
        const lastPage = Math.max(1, Math.ceil(this.activeCodes.length / this.codesPageSize))
        if (this.codesPage > lastPage) {
          this.codesPage = lastPage
        }
      },
      clearCurrentInterval (couponInterval) {
        this.errorInterval = null
        if (!couponInterval) {
          this.coupons.interval_settings = []
        }
      },
      addNewCascade () {
        this.coupons.is_waterfall = true
        if (!this.coupons.waterfall_discounts) {
          // this.coupons.waterfall_discounts = []
          Vue.set(this.coupons, 'waterfall_discounts', [])
        }
        this.coupons.waterfall_discounts.push({
          'from_value': '',
          'discount_value': ''
        })
      },
      deleteCascade (index) {
        this.coupons.waterfall_discounts.splice(index, 1)
        this.$nextTick(function () {
          if (!this.coupons.waterfall_discounts.length && !this.coupons.from_value) {
            this.coupons.is_waterfall = false
          }
        })
      },
      handleAutoApply () {
        if (this.coupons.auto_apply) {
          this.coupons.second_use_auto_coupon = false
          this.coupons.coupon_has_multiple_codes = false
        } else {
          this.coupons.auto_apply = false
        }
      }
    }
  }
</script>
<style>
  .interval-field-error .el-input__inner {
    border-color: #f56c6c;
  }
  .coupon-automation-nocode {
    padding: 8px 12px;
    border-radius: 6px;
    background: #f3eefb;
    border: 1px solid #d1c4e9;
    color: #5e35b1;
    font-size: 13px;
  }
  .coupon-subscription-nocode {
    padding: 8px 12px;
    border-radius: 6px;
    background: #f5faff;
    border: 1px solid #bbdefb;
    color: #1565c0;
    font-size: 13px;
  }
  .interval-field-error .el-input__inner:focus {
    border-color: #f56c6c;
  }
  /* outside the campaign wizard (.vue-form-wizard rules in _custom.scss): text centered on the
     26px checkbox box (label::before starts at -2px => line-height 22px, no negative margin) */
  .coupon-fields--standalone .checkbox .coupon-selection {
    display: inline-block;
    padding: 0 0 0 10px;
    margin: 0 0 20px;
    line-height: 22px;
    vertical-align: top;
    cursor: pointer;
    font-weight: 500;
  }
  .coupon-fields--standalone .generate-code {
    border-radius: 7px;
    text-transform: capitalize;
  }
  .coupon-code-row {
    display: flex;
    align-items: flex-start;
    gap: 15px;
  }
  .coupon-code-row__main {
    flex: 1;
    min-width: 0;
  }
  .coupon-qr {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding-top: 24px;
  }
  .coupon-qr__img {
    width: 120px;
    height: 120px;
    border: 1px solid #eee;
    border-radius: 4px;
  }
  .coupon-generator {
    border: 1px solid #d1c4e9;
    background: #faf8ff;
    padding: 10px 15px;
    margin-bottom: 15px;
  }
  .coupon-code-item {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    margin-bottom: 8px;
  }
  .coupon-code-item__qr {
    flex: 0 0 36px;
    width: 36px;
    height: 36px;
  }
  .coupon-code-item__qr img {
    display: block;
    width: 36px;
    height: 36px;
    border: 1px solid #eee;
    border-radius: 3px;
  }
  .coupon-code-item__qr--empty {
    border: 1px dashed #e0e0e0;
    border-radius: 3px;
  }
  .coupon-code-item__input {
    flex: 1;
    min-width: 0;
  }
  .coupon-code-item--used .coupon-code-item__input {
    text-decoration: line-through;
    color: #999;
  }
  /* same width for all statuses => the code inputs stay aligned */
  .coupon-code-status {
    flex: 0 0 110px;
    width: 110px;
    box-sizing: border-box;
    text-align: center;
    font-size: 11px;
    line-height: 1.4;
    padding: 2px 6px;
    border-radius: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .coupon-code-status--available {
    background: #e8f5e9;
    color: #2e7d32;
    border: 1px solid #c8e6c9;
  }
  .coupon-code-status--used {
    background: #fdecea;
    color: #c62828;
    border: 1px solid #f5c6cb;
  }
  .coupon-code-status--new {
    background: #ede7f6;
    color: #5e35b1;
    border: 1px solid #d1c4e9;
  }
  .coupon-codes-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Campaigns/Steps/ForthStep.vue